import { DIALOG } from 'constants/dialog';
import { useStore } from 'stores';
import SocialLogin from './SocialLogin';

const DialogComponent = {
  [DIALOG.socialLogin]: <SocialLogin />,
};

export default function Dialog() {
  const dialog = useStore((state) => state.dialog);
  const closeDialog = useStore((state) => state.closeDialog);

  if (dialog) {
    return (
      <div
        className="fixed top-0 flex flex-col justify-center w-screen h-screen items-center bg-sky"
        onClick={closeDialog}
      >
        <div onClick={(e) => e.stopPropagation()}>{DialogComponent[dialog]}</div>
      </div>
    );
  }
  return null;
}
